/* eslint-disable import/no-dynamic-require */
/* eslint-disable no-shadow */

const state = {
	tinyMce: false,
	loadingPost: false,
	wpChecking: false,
	wpSyncing: false,
	pendingPosts: 0,
	pendingCoupons: 0,
};

const getters = {
	'flags/tinyMce': state => state.tinyMce,
	'flags/loadingPost': state => state.loadingPost,
	'flags/wpChecking': state => state.wpChecking,
	'flags/wpSyncing': state => state.wpSyncing,
	'flags/pendingPosts': state => state.pendingPosts,
	'flags/pendingCoupons': state => state.pendingCoupons,
};

const mutations = {
	CHANGE_FLAGS(state, payload) {
		state[payload.flag] = payload.value;
	},
	RESET_FLAGS(state) {
		state.tinyMce = false;
		state.loadingPost = false;
		state.wpChecking = false;
		state.wpSyncing = false;
		state.pendingPosts = 0;
		state.pendingCoupons = 0;
	},
};

const actions = {

};

export default {
	state,
	getters,
	actions,
	mutations,
};
